import { render, staticRenderFns } from "./child.vue?vue&type=template&id=179e522f"
import script from "./child.vue?vue&type=script&lang=js"
export * from "./child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports